<template lang="pug">
  <div id="containDiv" >
    <div data-v-1690f989="" >
      <div class="clickMe" @click="openNB">点我直接跳过</div>
      <div title="是否显示视频" v-if="checkStatus()">
        <video autoplay="autoplay" muted="muted" loop="loop" class="swiper-lazy swiper-lazy-loaded" style="width:100%; display:block;" data-v-1690f989="" src="https://ai.wisewater.cn/a1ssl-dk50-jfas3-df2.mp4"></video> 
      </div>
    </div>
  </div>
</template>

<script>
import SmartForm from '@/components/SmartForm'

var checkStatus = true
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  checkStatus = false
}

export default {
  name: 'change-password',
  components: {
    SmartForm
  },
  created () {
    this.getData()
  },
  data () {
    return {
      title: '联系我们',
      company: '珠海智通信息技术有限公司',
      phoneInfo: '0756-2296166',
      userInfo: '李经理',
      emailInfo: 'iwise@wisewater.com.cn',
      addressInfo: '广东省珠海市国家高新技术开发区大学路101号清华科技园创业大楼B座1103-1106单元',
      mobileInfo: '400-8838-031',
      timeInfo: '周一至周五 08:30-18:00'
    }
  },
  methods: {
    checkStatus () {
      return checkStatus
    },
    getData () {
      console.log('首页')
      this.$message({
        type: 'success',
        message: '欢迎你'
      })
    },
    openNB () {
      this.$router.push('/nb')
    }
  }
}
</script>

<style lang="sass" scoped>
.clickMe
 position: absolute
 right: 15px
 top: 20px
 z-index: 10
 background-color: rgba(37,37,37,.7)
 color: #fff
 border-radius: 18px
 padding: 5px
 cursor: Pointer

</style>



// WEBPACK FOOTER //
// Welcome.vue?1dfe2554